import { useCallback } from "react";
import MuiAppBar, { AppBarProps as MuiAppBarProps } from "@mui/material/AppBar";
import { styled } from "@mui/material/styles";
import Toolbar from "@mui/material/Toolbar";
import { ArrowDropDown, PowerSettingsNew } from "@mui/icons-material";
import { useLanguage } from "../../locale/useLanguage";
// import { Logo } from "../Logo/Logo";
import { Grid } from "@mui/material";
// import { Link } from "react-router-dom";
import "./index.scss";
import { setCookie } from "../../helpers/cookie";
import {
  CallbackTranslation,
  TranslationKeys,
} from "locale/localizationContext";
import { RouteType } from "components/Router";
import {
  getFromLocalStorage,
  removeFromLocalStorage,
} from "helpers/localStorage";
import IconButtonMenu from "components/IconButtonMenu";
import { Link } from "react-router-dom";
import { Logo } from "components/Logo";

const drawerWidth = 240;
interface AppBarProps extends MuiAppBarProps {
  open?: boolean;
}

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})<AppBarProps>(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

function findMatchingRoute(currentPath: string, routes: RouteType[]) {
  for (const route of routes) {
    const routeRegex = new RegExp(
      `^${route.path.replace(/:[^/]+/g, "([^/]+)")}$`,
    );
    if (routeRegex.test(currentPath)) {
      return route;
    }
  }

  return null;
}

function getNavbarTitleAndSubtitle(
  currentPath: string,
  routes: RouteType[],
  t: CallbackTranslation,
): [string, string] {
  const route = findMatchingRoute(currentPath, routes);
  if (!route) return ["", ""];

  const pathParts = currentPath.split("/").filter((part) => part !== "");
  if (pathParts.length === 1) {
    return [t(route.titleLocalizationKey as TranslationKeys<string>), ""];
  }

  // if (route.id === "stats") {
  //   const category = pathParts[1];
  //   const categoryLocalizationKey = `pages.stats.stats_type.${category}.title`;

  //   if (pathParts.length === 2) {
  //     return [
  //       t(categoryLocalizationKey as TranslationKeys<string>),
  //       t("pages.stats.pages.type_selection.section"),
  //     ];
  //   }

  //   if (pathParts.length === 3) {
  //     const id = pathParts[2];
  //     const idLocalizationKey = `pages.stats.stats_type.${category}.${id}`;
  //     return [
  //       t(categoryLocalizationKey as TranslationKeys<string>),
  //       t(idLocalizationKey as TranslationKeys<string>),
  //     ];
  //   }
  // }

  // if (route.id === "products") {
  //   const section = pathParts[1];
  //   const families = JSON.parse(sessionStorage.getItem("families") || "[]");
  //   const sectionTitle = families.find((f: any) => f.id === section)?.name;

  //   if (pathParts.length === 2) {
  //     return [
  //       sectionTitle ?? section,
  //       t("pages.products.pages.model_selection.step_name"),
  //     ];
  //   }

  //   if (pathParts.length === 3) {
  //     const id = pathParts[2];
  //     const idTitle = id.replace(/_/g, " ");
  //     return [sectionTitle, idTitle];
  //   }
  // }

  // if (route.id === "cart") {
  //   const title = t(route.titleLocalizationKey as TranslationKeys<string>);
  //   const subtitle = t(
  //     `pages.cart.pages.${pathParts[1]}.title` as TranslationKeys<string>
  //   );

  //   return [title, subtitle];
  // }

  return [t(route.titleLocalizationKey as TranslationKeys<string>), ""];
}

const AppHeaderAdmin = ({
  open,
  bigHeader,
  menu,
}: {
  open?: boolean;
  bigHeader?: boolean;
  menu?: Array<RouteType>;
}) => {
  const { username } = (getFromLocalStorage() as any) || {};
  const [t] = useLanguage();
  const [title, subtitle] = getNavbarTitleAndSubtitle(
    window.location.pathname,
    menu || [],
    t,
  );

  const logout = useCallback(async () => {
    setCookie("token", "", -1);
    setCookie("role", "");
    removeFromLocalStorage("username");
    removeFromLocalStorage("shippingUnitCost");
    window.location.href = "/login";
  }, []);

  return (
    <>
      <AppBar position="fixed" open={open} className="background-none">
        <Toolbar className={bigHeader ? "admin-header-big" : "admin-header"}>
          <Grid
            container
            justifyContent="space-between"
            sx={{ height: "100%" }}
          >
            <Grid item container xs={6} md={3} alignItems="center">
              <Link to={"/"} style={{ height: "40px" }}>
                <Logo />
              </Link>
            </Grid>
            <Grid
              item
              container
              md={6}
              sx={{
                display: { xs: "none", sm: "none", md: "flex", lg: "flex" },
              }}
              justifyContent="center"
              className={`navbar-page-title ${
                (title + " | " + subtitle).length >= 50 ? "long-text" : ""
              }`}
            >
              <div
                style={{
                  display: "flex",
                  columnGap: "10px",
                  flexWrap: "wrap",
                  justifyContent: "center",
                }}
              >
                {title && <span>{title}</span>}
                {subtitle && <span>|</span>}
                {subtitle && <span>{subtitle}</span>}
              </div>
            </Grid>
            <Grid item container xs={6} md={3} alignContent="center">
              {username && (
                <Grid item container xs={12}>
                  <Grid
                    item
                    container
                    xs={10}
                    justifyContent="right"
                    alignItems="center"
                  >
                    <b>{username}</b>
                  </Grid>
                  <Grid item container xs={2} alignContent="center">
                    <IconButtonMenu
                      className="py-0"
                      icon={<ArrowDropDown />}
                      listItemMenu={[
                        {
                          icons: [<PowerSettingsNew />],
                          label: t("common.logout"),
                          onClick: logout,
                        },
                      ]}
                    />
                  </Grid>
                </Grid>
              )}
            </Grid>
          </Grid>
        </Toolbar>
      </AppBar>
    </>
  );
};
export default AppHeaderAdmin;
